import { defineMessages } from 'react-intl';

export default defineMessages({
    // add string ids and default values for localization here
    plBrokerageCommission: {
        id: 'quoteandbind.views.common.quote.Brokerage Commission',
        defaultMessage: 'Brokerage Commission',
    },
    plMimimumRetainedPremium: {
        id: 'quoteandbind.views.common.quote.Mimimum Retained Premium',
        defaultMessage: 'Mimimum Retained Premium',
    },
});